import { Component } from '@angular/core';
import { BannerComponent } from 'app/shared/components/banner/banner.component';
import { MainLayoutComponent } from 'app/shared/components/layouts/main-layout/main-layout.component';
import { Themes } from 'themes';

@Component({
  selector: 'ez-verification-error',
  imports: [BannerComponent, MainLayoutComponent],
  templateUrl: './verification-error.component.html',
  styleUrl: './verification-error.component.scss',
})
export class VerificationErrorComponent {
  Themes = Themes;
}
